<div class="container-xxl mx-0 pb-4">
    <div class="title-row d-flex justify-content-between align-items-center gap-4 mb-4">
        <p class="text-secondary mb-0">
            {{ 'customizedexports_export_template_description' | translate: 'online' : 'export' }}
        </p>
        <button
            type="button"
            class="btn btn-outline-secondary d-inline-flex align-items-center gap-2 flex-shrink-0"
            (click)="startOver()">
            <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
            {{ 'customizedexports_export_reset' | translate: 'online' : 'export' }}
        </button>
    </div>

    <app-step-flow
        headingKey="customizedexports_export_tab_customized_exports"
        [steps]="slots()"
        [limits]="form.exportLimits()"
        [statuses]="form.stepStatuses()">
        <div class="d-flex flex-column align-items-end gap-2">
            <div class="d-flex align-items-center gap-2">
                @if (form.deliversOnSchedule()) {
                    <app-export-test-button />
                }
                <app-action-button
                    [label]="{key: 'customizedexports_export_save', module: 'export'}"
                    [busy]="form.isSaving()"
                    [disabled]="form.saveDisabled()"
                    (run)="form.save()" />
            </div>
        </div>
    </app-step-flow>
</div>
